import React from "react";
import education from "../../assets/img/education/education.webp";
import education01 from "../../assets/img/education/education01.webp";
import education02 from "../../assets/img/education/education02.webp";
import TopTitleBlock from "../../Components/TopTitleBlock/TopTitleBlock";
import EducationModules from "./EducationComponents/EducationModules";
import {useSelector} from "react-redux";

const Education = () => {
  const apiData = useSelector((state)=>state.appData.appData)
  return (
    <div className="page__content">
      <TopTitleBlock titleBack={apiData.button_back} title={"ОБУЧЕНИЕ"} />
      <div className="page__education education">
        <div className="education__top top-education">
          <div className="top-education__row">
            <div className="top-education__column">
              <div className="top-education__img top-education__img-big">
                <img src={education} alt="education_img" />
              </div>
            </div>
            <div className="top-education__column">
              <div className="top-education__img">
                <img src={education01} alt="education_img" />
              </div>
            </div>
            <div className="top-education__column">
              <div className="top-education__img">
                <img src={education02} alt="education_img" />
              </div>
            </div>
          </div>
        </div>
        <div className="education__bottom bottom-education">
          <div className="bottom-education__text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet, velit
            facilisi viverra mattis ultricies bibendum rhoncus. Porttitor
            consequat cursus mauris nisl. Sed nibh diam velit leo, sit. Dolor
            placerat augue tincidunt feugiat nisl.
          </div>
          <div className="bottom-education__text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet, velit
            facilisi viverra mattis ultricies bibendum rhoncus. Porttitor
            consequat cursus mauris nisl. Sed nibh diam velit leo, sit. Dolor
            placerat augue tincidunt feugiat nisl.
          </div>
          <button className="bottom-education__btn btn-main">
            НАЧНИ ПРЯМО СЕЙЧАС
          </button>
        </div>
      </div>
      <EducationModules title={"Модули"} link={"module"} />
    </div>
  );
};

export default Education;
